export const convertSvgToBase64 = (svgContent: string): string =>
  `data:image/svg+xml;base64,${btoa(svgContent)}`;
